define('app/models/configurable_options',['app/setup'], function(takhfifan) {

  takhfifan.ConfigurableOptions = Backbone.Model.extend({

    initialize: function(args) {
      var choices = {};

      _.each(args.superAttributes, function(sa){
        choices[sa] = null;
      });

      this.set({
        products: [],
        superAttribute: null,
        superAttributes: args.superAttributes,
        basePrice: parseInt(args.basePrice),
        choices: choices
      });
      this.resetAdjustments();
    },

    resetAdjustments: function() {
      var adjustments = {};

      _.each(this.get('superAttributes'), function(sa){
        adjustments[sa] = 0;
      });

      this.set('adjustments', adjustments);
    },

    updateOptions: function(options) {
      var new_sa = options.superAttribute;
      var new_products = options.products;
      var new_id = options.optionId;
      var adjustments = this.get('adjustments');

      adjustments[new_sa] = parseInt(options.price);

      var choices = this.get('choices');
      choices[new_sa] = new_id;

      this.set({
        superAttribute: new_sa,
        adjustments: adjustments,
        products: new_products,
        choices: choices
      });

      takhfifan.eventHub.trigger('productoptions:' + this.get('id'), this);
    },

    adjustment: function(sa) {
      var adjustments = this.get('adjustments');
      return adjustments[sa];
    },

    price: function() {
      var adjustments = this.get('adjustments');
      var price = this.get('basePrice');

      _.each(this.get('superAttributes'), function(sa) {
        price += adjustments[sa];
      });

      return price;
    },

    optionAdjustment: function(price, sa) {
      var p = parseInt(price);
      return (sa == null) ? p : p - this.adjustment(sa);
    }
  });

});

